import { render, staticRenderFns } from "./SearchContacts.vue?vue&type=template&id=e22bf406&scoped=true&lang=pug&"
import script from "./SearchContacts.vue?vue&type=script&lang=js&"
export * from "./SearchContacts.vue?vue&type=script&lang=js&"
import style0 from "./SearchContacts.vue?vue&type=style&index=0&id=e22bf406&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22bf406",
  null
  
)

export default component.exports